'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinnerThird } from '@awesome.me/kit-94e593bf23/icons/classic/light'

/**
 * Reusable loading spinner component
 *
 * Usage:
 *   <Spinner />                        // Default with "Loading..." label
 *   <Spinner size="sm" />              // Small
 *   <Spinner size="lg" />              // Large
 *   <Spinner label="Please wait..." /> // Custom label
 *   <Spinner label={false} />          // No label (icon only)
 */
const Spinner = ({ size = 'md', label = 'Loading...' }) => {
    const sizeClasses = {
        sm: 'text-base',
        md: 'text-2xl',
        lg: 'text-4xl',
    }

    return (
        <div className="flex flex-col items-center gap-3">
            <FontAwesomeIcon
                icon={faSpinnerThird}
                className={`animate-spin text-primary ${sizeClasses[size]}`}
            />
            {label && (
                <span
                    className="text-sm bg-gradient-to-r from-gray-30 via-primary to-gray-30 bg-[length:200%_100%] bg-clip-text text-transparent animate-color-sweep"
                >
                    {label}
                </span>
            )}
        </div>
    )
}

export default Spinner
